import React, { Component } from "react";
import { Route } from "react-router-dom";
import axios from "axios";
import { TranslatePage } from "../translation/TranslatePage";
import { ConfigurationKeysPage } from "../configuration-keys/ConfigurationKeysPage";
import { checkPrivilege, Label } from "clavis-nxt-components-custdevtm";
import "./ModuleContainer.scss";

export const UI_MENU_CONFIGURATION_KEYS_READ =
  "ui_menu_configuration_keys_read";
export const UI_MENU_CLOCKWORK = "ui_menu_clockwork";
export const UI_MENU_TRANSLATION_READ = "ui_menu_translation_read";

class ModuleContainer extends Component {
  loadModules = () => {
    const moduleUrls = [
      process.env.REACT_APP_CUSTDEVTM_MODULE_PATH,
      process.env.REACT_APP_CLOCKWORK_MODULE
    ];

    if (this.props.moduleConfig && this.props.moduleConfig.modules) {
      const moduleUrlsFromConfig = Object.keys(
        this.props.moduleConfig.modules
      ).map(key => this.props.moduleConfig.modules[key].clnt);

      moduleUrls.push(...moduleUrlsFromConfig);
    }

    console.log("moduleUrls", moduleUrls);

    moduleUrls.forEach(url => {
      axios.get(`${url}?ts=${Date.now()}`).then(response => {
        const extractedFilename = response.data.substring(
          response.data.indexOf('"') + 1,
          response.data.lastIndexOf('"')
        );

        const script = document.createElement("script");
        script.src = url + extractedFilename;

        document.head.appendChild(script);
      });
    });
  };

  componentDidMount() {
    this.loadModules();
  }

  alertPanel = () => {
    let noPageAuth = "Page authorization failed!";
    return (
      <div
        className={
          "alert-panel failed-result-background-color edit-border-color-active"
        }
      >
        <i className={"icon icon-alert icon-small"} />
        <Label>{noPageAuth}</Label>
      </div>
    );
  };

  render() {
    return (
      <div
        id={"module-content-container"}
        className={"module-content-container"}
        style={{ height: "100%" }}
      >
        <Route exact path="/nxt" component={() => <custdevtm-pages />} />
        <Route
          exact
          path="/nxt/configuration-keys"
          render={() =>
            checkPrivilege(UI_MENU_CONFIGURATION_KEYS_READ) ? (
              <ConfigurationKeysPage />
            ) : (
              this.alertPanel()
            )
          }
        />
        <Route
          path="/nxt/clockwork"
          render={() =>
            checkPrivilege(UI_MENU_CLOCKWORK) ? (
              <clockwork-pages />
            ) : (
              this.alertPanel()
            )
          }
        />
        <Route
          exact
          path="/nxt/translation"
          render={() =>
            checkPrivilege(UI_MENU_TRANSLATION_READ) ? (
              <TranslatePage />
            ) : (
              this.alertPanel()
            )
          }
        />
        <Route path="/nxt/custdevtm" component={() => <custdevtm-pages />} />
      </div>
    );
  }
}

export default ModuleContainer;
